(ns ui.view.card.counterparty-diligence-responder.sub
  (:require
   [re-frame.core :as rf]
   [ui.view.card.counterparty-diligence-responder.model :as model]
   [ui.view.card.sub :as common-sub]))

(rf/reg-sub
 ::primary-entity
 (fn [[_ ctx]]
   [(rf/subscribe [::common-sub/entities ctx])])
 (fn [[entities] [_ {:keys [entity-id] :as _ctx}]]
   (get entities entity-id)))

(rf/reg-sub
 ::responder
 (fn [[_ ctx]]
   [(rf/subscribe [::primary-entity ctx])
    (rf/subscribe [::common-sub/entities ctx])])
 (fn [[primary-entity card-entities]]
   (let [responder-id (some-> primary-entity
                              (get :counterparty-diligence/responder)
                              first)
         responder (when responder-id
                     (get card-entities responder-id))]
     responder)))

(rf/reg-sub
 ::responder?
 (fn [[_ ctx]]
   [(rf/subscribe [::primary-entity ctx])
    (rf/subscribe [::common-sub/entities ctx])])
 (fn [[primary-entity _card-entities]]
   (some-> primary-entity
           (get :counterparty-diligence/responder)
           first)))

(rf/reg-sub
 ::responder-email
 (fn [[_ ctx]]
   [(rf/subscribe [::responder ctx])])
 (fn [[responder]]
   (:person/universal-email-address responder)))

(rf/reg-sub
 ::send-to-responder-modal-open?
 common-sub/card-state-extractor
 (fn [[card-state]]
   (get-in card-state model/send-to-responder-modal-open-path)))

(rf/reg-sub
 ::email-subject-line
 common-sub/card-state-extractor
 (fn [[card-state]]
   (get-in card-state model/email-subject-line-path "")))

(rf/reg-sub
 ::email-body
 common-sub/card-state-extractor
 (fn [[card-state]]
   (get-in card-state model/email-body-path "")))

(rf/reg-sub
 ::companies-to-check
 common-sub/card-state-extractor
 (fn [[card-state]]
   (get-in card-state model/companies-to-check-path [])))

(rf/reg-sub
 ::people-to-check
 common-sub/card-state-extractor
 (fn [[card-state]]
   (get-in card-state model/people-to-check-path [])))
